export enum visitorStatus {
  All = "all",
  Expected = "expected",
  SignedIn = "signedIn",
  SignedOut = "signedOut",
}
